import { type RefObject, useEffect, useState } from "react";

import useThrottle from "./useThrottle";

const useRefDimensions = (ref: RefObject<HTMLElement> | null) => {
  const [dimensions, setDimensions] = useState({
    height: 0,
    width: 0,
  });
  const setDimensionsThrottled = useThrottle(setDimensions, 50);

  useEffect(() => {
    if (!ref?.current) {
      setDimensionsThrottled({ height: 0, width: 0 });
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      if (!ref.current) return;
      const { width, height } = ref.current.getBoundingClientRect();
      setDimensionsThrottled({ height, width });
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect();
  }, [ref?.current]);

  return dimensions;
};

export default useRefDimensions;
